import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

const StyledSiteBackgroundVideo = styled.div`
  height: 100vh;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 0;

  video {
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &:after {
    background: ${(props) =>
      props.light ? 'rgba(255, 255, 255, 0.34)' : 'rgba(0, 0, 0, 0.28)'};
    content: '';
    display: ${(props) => (props.showOverlay ? 'block' : 'none')};
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

function SiteBackgroundVideo({ src, light = false, showOverlay = true }) {
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    video.muted = true
    video.defaultMuted = true
    video.playsInline = true

    const play = video.play()
    if (play && typeof play.catch === 'function') play.catch(() => {})
  }, [src])

  if (!src) return null

  return (
    <StyledSiteBackgroundVideo
      className="site-background-video"
      light={light}
      showOverlay={showOverlay}
    >
      <video
        ref={videoRef}
        autoPlay
        defaultMuted
        loop
        muted
        playsInline
        preload="auto"
        src={src}
        onCanPlay={(e) => {
          const play = e.currentTarget.play()
          if (play && typeof play.catch === 'function') play.catch(() => {})
        }}
      />
    </StyledSiteBackgroundVideo>
  )
}

export default SiteBackgroundVideo
